import React from 'react'

import { useDictionaryData } from '@/components/shared/DictionaryProvider/hooks'

import { SuccessfulOperation } from './SuccessfulOperation'

import type { SuccessfulOperationWrapperProps } from './types'

export const SuccessfulEmployeeEmail = ({
  onGoBack,
}: SuccessfulOperationWrapperProps) => {
  const { dictionary } = useDictionaryData()

  return (
    <SuccessfulOperation
      onGoBack={onGoBack}
      title="Shortlist Sent"
      description={`The ${dictionary.employee?.toLowerCase()} will receive an email to review these options`}
      buttonText="Back to Shortlist"
    />
  )
}
